import { useMemo } from "react";
import {
  CA_SAVINGS_COLDEF,
  CA_TOTAL_SAVINGS_COLDEF,
  OG_BASELINE_SAVINGS_COLDEF,
  OG_BASELINE_TOTAL_SAVINGS_COLDEF,
  OG_CA_FARE_COLDEF,
  OG_CA_SAVINGS_COLDEF,
  OG_CA_TOTAL_SAVINGS_COLDEF,
  ONEWAY__OG_CARRIER_COLDEF,
  OG_FARE_COLDEF,
  ONEWAY__OG_FLIGHTNO_COLDEF,
  OG_TARGET_SAVINGS_COLDEF,
  OG_TARGET_TOTAL_SAVINGS_COLDEF,
  ROUNDTRIP_F1__OG_FLIGHTNO_COLDEF,
  ROUNDTRIP_F2__OG_FLIGHTNO_COLDEF,
  ROUNDTRIP_F1__OG_CARRIER_COLDEF,
  ROUNDTRIP_F2__OG_CARRIER_COLDEF,
} from "./common-coldefs";
import { useMeData } from "../hooks/useMe";
import { useAppMode, useItinMode } from "../store/model-misc";

const SAXECAP_DEV_SPECIAL_FIELDS = new Set(
  [
    OG_BASELINE_SAVINGS_COLDEF,
    OG_BASELINE_TOTAL_SAVINGS_COLDEF,
    OG_TARGET_SAVINGS_COLDEF,
    OG_TARGET_TOTAL_SAVINGS_COLDEF,
    OG_CA_FARE_COLDEF,
    CA_SAVINGS_COLDEF,
    CA_TOTAL_SAVINGS_COLDEF,
    OG_CA_SAVINGS_COLDEF,
    OG_CA_TOTAL_SAVINGS_COLDEF,
    OG_FARE_COLDEF,
    ONEWAY__OG_FLIGHTNO_COLDEF,
    ROUNDTRIP_F1__OG_FLIGHTNO_COLDEF,
    ROUNDTRIP_F2__OG_FLIGHTNO_COLDEF,
    ONEWAY__OG_CARRIER_COLDEF,
    ROUNDTRIP_F1__OG_CARRIER_COLDEF,
    ROUNDTRIP_F2__OG_CARRIER_COLDEF,
  ].map(({ field }) => field)
);

export function useMaybeWithSaxecapDevColDefs(startingDefs) {
  const appMode = useAppMode();
  const itinMode = useItinMode();
  const { role, timezone } = useMeData();
  return useMemo(() => {
    let colDefs = [...startingDefs];
    if (role !== "saxecap_dev") {
      colDefs = colDefs.filter(
        ({ field }) => !SAXECAP_DEV_SPECIAL_FIELDS.has(field)
      );
    }
    const appModeFilter = (cd) => filterToColdefsForAppmode(cd, appMode);
    const itinModeFilter = (cd) => filterToColdefsForItinmode(cd, itinMode);
    colDefs = colDefs
      .map((cd) => maybeAddUserTimezone(cd, timezone))
      .filter(appModeFilter)
      .filter(itinModeFilter);
    return colDefs;
  }, [role, startingDefs, timezone, appMode, itinMode]);
}

export function filterToColdefsForAppmode(coldef, appmode) {
  const cdam = coldef.__appMode;
  return cdam === undefined || cdam === appmode;
}

export function filterToColdefsForItinmode(coldef, itinmode) {
  const cdim = coldef.__itinMode;
  return cdim === undefined || cdim === itinmode;
}

export function maybeAddUserTimezone(colDef, timezone) {
  if (colDef.type !== "timestampColumn") {
    return { ...colDef };
  } else if (colDef.__timezone !== "auto") {
    return { ...colDef };
  } else {
    return { ...colDef, __timezone: timezone };
  }
}
